import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  Lock,
  LockOpen,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import MuiAlert from "@material-ui/lab/Alert";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  datepicker: {
    display: "flex",
    alignItems: "baseline",
  },
  table: {
    // width: "1600px",
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  contractCell: {
    width: "120px",
  },
  lockIconCell: {
    width: "110px",
  },
  lockIcon: {
    textAlign: "center",
    color: "rgb(220, 0, 78)",
  },
  lockOpenIcon: {
    textAlign: "center",
    color: "#19857b",
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  selectFormControl: {
    width: "250px"
  },
}));

function Dtm(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [dtms, setDtms] = React.useState([]);
  const [initTypes, setInitTypes] = React.useState([]);
  const [dtmConfigs, setDtmConfigs] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(null);

  // 絞込フォームパラメータ
  const [adminName, setAdminName] = React.useState("");
  const [desc, setDesc] = React.useState("");
  const [dtmNotice, setDtmNotice] = React.useState([]);
  const [contractType, setContractType] = React.useState([]);
  const [locked, setLocked] = React.useState("true");
  // 告知タイプ設定フォームパラメータ
  const [selectDtmNotice, setSelectDtmNotice] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - DTM告知一括管理";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchDtms();
    fetchContracts();
    fetchDtmConfigs();
  }, [auth.state.token]);

  const fetchDtms = () => {
    request({
      method: "GET",
      url: `admin/dtm_notices`,
    }).then((result) => {
      setDtms(result.data.data);
    });
  };

  const fetchContracts = () => {
    request({
      method: "GET",
      url: `admin/contracts`,
    })
      .then((result) => {
        setInitTypes(result.data.data.types);
      });
  };

  const fetchDtmConfigs = () => {
    request({
      method: "GET",
      url: `admin/dtm_configs?${convertQueryParam({
        filter: {
          name: adminName,
          desc: desc,
          dtm_notice: dtmNotice,
          type: contractType,
          locked: locked,
        },
      })}`,
    }).then((result) => {
      setDtmConfigs(result.data.data);
    });
  };

  // 現告知タイプのチェックボックス制御
  const handleDtmNoticeChange = (event) => {
    if (event.target.checked) {
      // チェックを付けた値を追加
      setDtmNotice([ ...dtmNotice, Number(event.target.name)]);
    } else {
      // チェックを外した値を削除
      setDtmNotice(dtmNotice.filter(item => item != Number(event.target.name)));
    }
  };

  // 契約タイプのチェックボックス制御
  const handleContractTypeChange = (event) => {
    if (event.target.checked) {
      // チェックを付けた値を追加
      setContractType([ ...contractType, event.target.name]);
    } else {
      // チェックを外した値を削除
      setContractType(contractType.filter(item => item != event.target.name));
    }
  };

  // 選択した告知タイプを絞り込まれたアカウントに一括設定
  const settingDtmNotice = () => {
    setSuccess(null);
    setSuccessMessage(null);

    const accounts = dtmConfigs.map(dtmConfig => {
      return dtmConfig.id
    });

    request({
      method: "PUT",
      url: `admin/dtm_configs`,
      data: {
        accounts: accounts,
        dtm_notice: selectDtmNotice
      },
    }).then((result) => {
      setSuccess(true);
      setSuccessMessage("設定が完了しました");
      fetchDtmConfigs();
      setIsShowModal(false);
    });
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.desc}</TableCell>
          <TableCell>{row.notice ? row.notice.label : '-'}</TableCell>
          <TableCell>{row.type ? row.type : '-'}</TableCell>
          {row.locked ? 
            <TableCell className={classes.lockIcon}><Lock /></TableCell> : 
            <TableCell className={classes.lockOpenIcon}><LockOpen /></TableCell>
          }
        </TableRow>
      </React.Fragment>
    );
  };

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <ValidatorForm
                onSubmit={(e) => {
                  e.preventDefault();
                  fetchDtmConfigs();
                }}
              >
                <Typography variant="h6" color="primary">
                  絞込条件（And条件）
                </Typography>
                <Grid container>
                  <Grid item xs={12} className={classes.wrapper}>
                    <TextValidator
                      label="アカウント名"
                      fullWidth
                      value={adminName}
                      onChange={(event) => {
                        setAdminName(event.target.value);
                      }}
                      type="text"
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.wrapper}>
                    <TextValidator
                      label="概要"
                      fullWidth
                      value={desc}
                      onChange={(event) => {
                        setDesc(event.target.value);
                      }}
                      type="text"
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.wrapper}>
                    <FormControl component="fieldset">
                      <FormLabel>現告知タイプ</FormLabel>
                      <FormGroup row>
                        {dtms.map((row, index) => 
                          <FormControlLabel
                            control={<Checkbox onChange={handleDtmNoticeChange} name={row.id} />}
                            label={row.label}
                          />
                        )}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} className={classes.wrapper}>
                    <FormControl component="fieldset">
                      <FormLabel>契約タイプ</FormLabel>
                      <FormGroup row>
                        {initTypes.map((row, index) => 
                          <FormControlLabel
                            control={<Checkbox onChange={handleContractTypeChange} name={row} />}
                            label={row}
                          />
                        )}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} className={classes.wrapper}>
                    <FormControl component="fieldset">
                      <FormLabel>ロック</FormLabel>
                      <RadioGroup 
                        row
                        name="locked"
                        value={locked}
                        onChange={(event) => {
                          setLocked(event.target.value);
                        }}
                      >
                        <FormControlLabel value={"true"} control={<Radio />} label="含む" />
                        <FormControlLabel value={"false"} control={<Radio />} label="含まない" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container justifyContent="center" className={classes.wrapper}>
                  <Button type="submit" variant="contained" color="primary">
                    絞り込む
                  </Button>
                </Grid>
              </ValidatorForm>
            </Paper>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                アカウント一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>名前</TableCell>
                    <TableCell>概要</TableCell>
                    <TableCell>告知タイプ</TableCell>
                    <TableCell className={classes.contractCell}>契約タイプ</TableCell>
                    <TableCell className={classes.lockIconCell}>ロック状態</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dtmConfigs.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            <Paper elevation={3} className={classes.paper}>
              <ValidatorForm
                onSubmit={(e) => {
                  e.preventDefault();
                  setIsShowModal(true);
                }}
              >
                <Typography variant="h6" color="primary">
                  設定する告知タイプ
                </Typography>
                <Grid container>
                  <Grid item xs={12} className={classes.wrapper}>
                    <FormControl className={classes.selectFormControl}>
                      <InputLabel>告知タイプ</InputLabel>
                      <Select
                        value={selectDtmNotice}
                        onChange={(event) => setSelectDtmNotice(event.target.value)}
                      >
                        <MenuItem value={null}>告知タイプクリア</MenuItem>
                        {dtms.map((row, index) => 
                          <MenuItem value={row.id}>{row.label}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container justifyContent="center" className={classes.wrapper}>
                  <Button 
                    type="submit" 
                    variant="contained" 
                    color="primary"
                    disabled={dtmConfigs.length == 0 || selectDtmNotice == ""}
                  >
                    設定する
                  </Button>
                </Grid>
              </ValidatorForm>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {successMessage}
              </MuiAlert>
            )}
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
               一覧に表示されているアカウントの告知タイプを一括で設定しますか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={() => settingDtmNotice()}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Dtm);
